import { useEffect } from 'react';

export default function useBodyClass(classNames, condition) {
  useEffect(() => {
    if (!condition) return;

    const rootElement = document.getElementById('root');
    if (!rootElement) return;

    // const classList = classNames.split(' ').filter(Boolean); // Évite les espaces vides

    // classList.forEach((cls) => document.body.classList.add(cls));

    rootElement.classList.add('overflow-hidden');
    rootElement.classList.add('h-screen');

    return () => {
      // classList.forEach((cls) => document.body.classList.remove(cls));

      //   document.body.classList.remove(classNames);

      rootElement.classList.remove('overflow-hidden');
      rootElement.classList.remove('h-screen');
    };
  }, [classNames, condition]);
}
